<div provide-parent-form id="channel-elements-container">
	<div class="main-container">
		<div id="channel-block-list">

			<!-- FeaturedHeader, placed outside of the other cdkdrag -->
			<div *ngIf="channel.blocks?.[0]?.type === 'FeaturedHeader'" class="featured-header-block channel-block">
				<bb-collapsible #blockCollapsible [hideShadow]="true" [suffixText]="true"
					[title]="'FEATURED_HEADER' | translate"
					[description]=""
					togglePosition="before">
					<div class="bb-collapsible-buttons">
						<i class="far fa-trash" (click)="deleteBLock($event, channel.blocks[0], true)"></i>
					</div>
					<h3>
						{{ 'SLIDES' | translate }}
					</h3>
					<div class="slides-container" cdkDropList [cdkDropListData]="channel.blocks[0].slides" (cdkDropListDropped)="featuredSlideDropped($event)">
						<bb-collapsible cdkDrag
							#slideEl
							*ngFor="let slide of channel.blocks[0].slides; let i = index"
							[title]="slide.header || (slide.contentId && ({
								type: slide.contentType,
								value: slide.contentId
							} | entityLabel:true | async)) || (('SLIDE' | translate) + ' ' + (i + 1))" togglePosition="before"
							[entity]="{
								type: (slide.featuredImageId || slide.contentType === 'mediaclip') && 'MediaClip' || slide.contentType === 'project' && 'Project' || slide.contentType === 'cliplist' && 'ClipList',
								mainMediaClipId: 'x',
								id: slide.featuredImageId || ((slide.contentType === 'mediaclip' || slide.contentType === 'project' || slide.contentType === 'cliplist') && slide.contentId)
							}"
							[hideShadow]="true">
							<div class="bb-collapsible-buttons">
								<i class="far fa-trash" (click)="deleteFeaturedSlide(channel.blocks[0], slide)"></i>
								<i class="far fa-bars"></i>
							</div>
							<div class="slide-container">
								<ng-container *ngTemplateOutlet="featuredConfigTemplate; context: {config: slide, renderId: slide.id, isHeader: true}"></ng-container>
							</div>
						</bb-collapsible>
					</div>

					<div class="button-container">
						<bb-button add-slide-button theme="light-v2" (click)="addFeaturedSlide(channel.blocks[0])" [disabled]="channel.blocks[0].slides?.length === 5">
							{{ 'ADD_SLIDE' | translate }}
						</bb-button>
					</div>
					
					<bb-collapsible [title]="'ADVANCED' | translate" togglePosition="before" theme="blue">
						<h3>{{"PLAYER_OPTIONS" | translate}}</h3>

						<bb-form-element [form]="form" theme="light-v2" [label]="'PAGE_LOGO' | translate"
							class="margin-bottom">
							<bb-logo-selector [showDropZone]="true" [name]="channel.blocks[0].id + '-config-logoImageId'"
								[useType]="'commercial'" [mediaTypes]="['image']"
								[(entityId)]="channel.blocks[0].config.logoImageId" [theme]="'light-v2'"
								[autoPublish]="true" (entityIdChange)="elementLogoChanged($event)"
								[dropTextRecommendation]="'CHANNEL_HEADER_FILE_RECOMMENDATION'">
							</bb-logo-selector>
						</bb-form-element>

						<div class="channel-group-block">
							<bb-form-element [form]="form" theme="light-v2"
								[label]="'BACKGROUND_IMAGE_MODE_MOBILE' | translate">
								<bb-radio-list [valueOnlyModel]="true" mode="image"
									[textAside]="true"
									[growItems]="true"
									[name]="channel.blocks[0].id+'-config-imageFitMode'" [(ngModel)]="channel.blocks[0].config.imageFitMode"
									[options]="imageFitModeOptions" maxColumns="3">
								</bb-radio-list>
							</bb-form-element>
						</div>


						<div class="channel-group-block">
							<bb-form-element [form]="form" theme="light-v2"
								[label]="'PLAYER_PLAY_IN' | translate">
								<bb-radio-list [valueOnlyModel]="true" mode="image"
									[name]="channel.blocks[0].id+'-config-playIn'" [(ngModel)]="channel.blocks[0].config.playIn"
									[options]="playInOptions" maxColumns="3">
								</bb-radio-list>
							</bb-form-element>
						</div>
					</bb-collapsible>

					<div class="button-container">
						<bb-button theme="light-v2" (click)="collapseElement(0, false)">{{ "CLOSE" | translate }}
						</bb-button>
					</div>

				</bb-collapsible>
			</div>
			<div class="blocks-container" cdkDropList [cdkDropListData]="channel.blocks"
				(cdkDropListDropped)="channelBlockDropped($event)" [cdkDropListSortPredicate]="checkDragAllowed">

				<ng-container *ngFor="let block of channel?.blocks; let i = index; trackBy: trackByIndex">
					<div class="channel-block" cdkDrag *ngIf="block.type !== 'FeaturedHeader'" [cdkDragDisabled]="['HeaderLogoTitle'].includes(block.type)">
						<bb-collapsible #blockCollapsible [hideShadow]="true" [suffixText]="true"
							[title]="(playlistTypes.includes(block.type) ? 'PLAYLIST' : block.type === 'Player' ? 'VIDEOPLAYER' : block.type.toUpperCase()) | translate"
							[description]="block.type === 'HeaderLogoTitle' ? ('LOGOTITLE' | translate | lowercase) : ['Grid', 'Carousel', 'Cliplist'].includes(block.type) ? (block.type.toUpperCase() | translate | lowercase) : ''"
							togglePosition="before">
							<div class="bb-collapsible-buttons">
								<i class="far fa-trash" (click)="deleteBLock($event, block, true)"></i>
								<i *ngIf="!['Player', 'HeaderLogoTitle'].includes(block.type)"
									class="far fa-copy" (click)="copyBlock($event, block)"></i>
								<i class="far fa-bars" *ngIf="!['HeaderLogoTitle'].includes(block.type)"></i>
							</div>
							<!-- START switch -->
							<ng-container [ngSwitch]="block.type">
								<div *ngSwitchCase="'HeaderLogoTitle'">
									<bb-form-element [form]="form" theme="light-v2" [label]="'LOGO_IMAGE' | translate"
										class="margin-bottom">
										<bb-logo-selector [showDropZone]="true" [name]="block.id+'-config-logoId'"
											[useType]="'commercial'" [mediaTypes]="['image']"
											[(entityId)]="block.config.logoId" [theme]="'light-v2'"
											(entityIdChange)="elementLogoChanged($event)" [autoPublish]="true"
											[dropTextRecommendation]="'CHANNEL_HEADER_FILE_RECOMMENDATION'">
										</bb-logo-selector>
									</bb-form-element>
	
									<mat-form-field appearance="fill" class="full-width">
										<mat-label>{{'TITLE' | translate}}</mat-label>
										<input [(ngModel)]="block.config.title" matInput name="channel_page_title">
									</mat-form-field>
								</div>
	
								<!-- Playlist (grid, carousel, cliplist ~ slider) -->
								<div *ngSwitchCase="'Grid'">
									<ng-container *ngTemplateOutlet="playListTemplate"></ng-container>
								</div>
								<div *ngSwitchCase="'Carousel'">
									<ng-container *ngTemplateOutlet="playListTemplate"></ng-container>
								</div>
								<div *ngSwitchCase="'Cliplist'">
									<ng-container *ngTemplateOutlet="playListTemplate"></ng-container>
								</div>

								<ng-template #playListTemplate>
									<mat-form-field appearance="fill" class="full-width pointer">
										<mat-label>{{ 'PLAYLIST' | translate }}</mat-label>
										<bb-entity-selector theme="light-v2" [inMatFormField]="true" [disableClear]="true"
											[hideThumbnail]="true" [hideIcons]="true" [entityType]="'playlist'"
											[(ngModel)]="block.config.contentId" [name]="block.id+'-config-contentId'"
											placeholder="" [filterSet]="[{
												filters: [{
													type: 'playlist',
													field: 'status',
													operator: 'isNot',
													value: 'draft'
												}]
											}]"></bb-entity-selector>
									</mat-form-field>

									<mat-form-field appearance="fill" class="full-width margin-bottom">
										<mat-label>{{'TITLE' | translate}}</mat-label>
										<mat-hint>{{"PLAYLIST_OPTIONAL" | translate}}</mat-hint>
										<input [(ngModel)]="block.config.header" matInput
											(mousedown)="$event.stopPropagation()" [name]="block.id+'-config-header'">
									</mat-form-field>

									<div class="channel-group-block">
										<bb-form-element [form]="form" [required]="true" theme="light-v2"
											[label]="'SELECT_TYPE_PLAYLIST' | translate" [hideRequiredMark]="true">
											<bb-radio-list [valueOnlyModel]="true" mode="image" [name]="block.id+'-type'"
												[(ngModel)]="block.type" [options]="playlistOptions" maxColumns="3">
											</bb-radio-list>
										</bb-form-element>
									</div>

									<div class="channel-group-block">
										<bb-form-element [form]="form" [label]="'SHOW_VIDEO_TITLES' | translate"
											theme="light-v2-row">
											<mat-slide-toggle [(ngModel)]="block.config.showClipTitles"
												[name]="block.id+'-config-showClipTitles'">
											</mat-slide-toggle>
										</bb-form-element>
									</div>

									<bb-collapsible [title]="'ADVANCED' | translate" togglePosition="before" theme="blue">
										<h3>{{"PLAYER_OPTIONS" | translate}}</h3>
										<div class="channel-group-block">
											<bb-form-element [form]="form" theme="light-v2"
												[label]="'PLAYER_PLAY_IN' | translate">
												<bb-radio-list [valueOnlyModel]="true" mode="image"
													[name]="block.id+'-config-playIn'" [(ngModel)]="block.config.playIn"
													[options]="playInOptions" maxColumns="3">
												</bb-radio-list>
											</bb-form-element>
										</div>

										<div class="channel-group-block">
											<bb-form-element [form]="form" [label]="'THUMBNAIL_IMAGE_SET' | translate" theme="light-v2">
												<bb-aspect-ratio-picker [(ngModel)]="block.config.aspectRatio" [name]="block.id+'-config-aspectRatio'" 
												[defaultOption]="block.config.aspectRatio ? null : 'DEFAULT' | translate" [valueProp]="'name'"
												[defaultOptionSublabel]="block.config.aspectRatio ? null : '16 / 9'"
												></bb-aspect-ratio-picker>
											</bb-form-element>
										</div>
									</bb-collapsible>
								</ng-template>

								<!-- Featured -->
								<div *ngSwitchCase="'Featured'">
									<ng-container *ngTemplateOutlet="featuredConfigTemplate; context: {config: block.config, renderId: block.id, isHeader: false}"></ng-container>
									<bb-collapsible [title]="'ADVANCED' | translate" togglePosition="before" theme="blue">
										<h3>{{"PLAYER_OPTIONS" | translate}}</h3>
										<div class="channel-group-block">
											<bb-form-element [form]="form" theme="light-v2"
												[label]="'PLAYER_PLAY_IN' | translate">
												<bb-radio-list [valueOnlyModel]="true" mode="image"
													[name]="block.id+'-config-playIn'" [(ngModel)]="block.config.playIn"
													[options]="playInOptions" maxColumns="3">
												</bb-radio-list>
											</bb-form-element>
										</div>
									</bb-collapsible>
								</div>

								<!-- Promotional -->
								<div *ngSwitchCase="'Promotional'">

									<div class="channel-group-block">
										<div class="channel-group-block no-padding-x no-padding-bottom">
											<bb-form-element [form]="form" [required]="true" theme="light-v2"
												[label]="'LAYOUT' | translate" [hideRequiredMark]="true">
												<bb-radio-list [valueOnlyModel]="true" mode="image"
													[name]="block.id+'-config-promoLayout'" [(ngModel)]="block.config.promoLayout"
													[options]="promotionalOptions" maxColumns="2">
												</bb-radio-list>
											</bb-form-element>
										</div>
									</div>
									
									<bb-form-element [form]="form" theme="light-v2" [label]="'PROMOTIONAL_IMAGE' | translate"
										class="margin-bottom">
										<bb-logo-selector [showDropZone]="true" [name]="block.id + '-config-promotionalImageId'"
											[useType]="'commercial'" [mediaTypes]="['image']"
											[(entityId)]="block.config.promotionalImageId" [theme]="'light-v2'"
											[autoPublish]="true" (entityIdChange)="elementLogoChanged($event)"
											[dropTextRecommendation]= "block.config.promoLayout === 'large' ? 'CHANNEL_PROMOTIONAL_LARGE_IMAGE_RECOMMENDATION' : 'CHANNEL_PROMOTIONAL_SMALL_IMAGE_RECOMMENDATION' ">
										</bb-logo-selector>
									</bb-form-element>

									<mat-form-field appearance="fill" class="full-width">
										<mat-label>{{'CLICK_THROUGH_URL' | translate}}</mat-label>
										<input [(ngModel)]="block.config.promotionalUrl" matInput
											(mousedown)="$event.stopPropagation()" [name]="block.id + '-config-promotionalUrl'">
									</mat-form-field>

									<ng-container *ngIf="block.config.promotionalUrl"> 
									<div class="channel-group-block">
									<bb-form-element [form]="form" [label]="'OPEN_NEW_TAB' | translate"
											theme="light-v2-row">
											<mat-slide-toggle [(ngModel)]="block.config.openInNewTab"
												[name]="block.id+'-config-openInNewTab'">
											</mat-slide-toggle>
										</bb-form-element>
									</div>
								</ng-container>
								</div>
							
								<!-- Player -->
								<div *ngSwitchCase="'Player'">
									<div class="channel-group-block no-padding-bottom ">
										<mat-form-field appearance="fill" class="full-width">
											<mat-label>{{"CONTENT_TYPE" | translate}}</mat-label>
											<mat-select [(ngModel)]="block.config.contentType"
												(ngModelChange)="playerContentTypeChanged(i)"
												[name]="block.id+'-config-contentType'">
												<mat-option *ngFor="let contentType of contentTypes"
													[value]="contentType.value">
													{{ contentType.label | translate }}
												</mat-option>
											</mat-select>
										</mat-form-field>
										<!-- display entity selector base on contentType chosen (resets when changing contentType) -->
										<ng-container *ngFor="let type of contentTypes">
											<ng-container *ngIf="block.config.contentType === type.value">
												<mat-form-field appearance="fill" class="full-width pointer">
													<mat-label>{{ 'SELECT_'+type.label | translate }}</mat-label>
													<bb-entity-selector theme="light-v2" [inMatFormField]="true"
														[disableClear]="true" [hideThumbnail]="true" [hideIcons]="true"
														[entityType]="type.value" [(ngModel)]="block.config.contentId"
														[name]="block.id+'-config-contentId'" placeholder="" [filterSet]="[{
														filters: [{
															type: type.value,
															field: 'status',
															operator: 'isNot',
															value: 'draft'
														}]
													}]"></bb-entity-selector>
												</mat-form-field>
											</ng-container>
										</ng-container>
									</div>

									<div class="channel-group-block">
										<bb-form-element [form]="form" [label]="'SHOW_VIDEO_TITLE' | translate"
											theme="light-v2-row">
											<mat-slide-toggle [(ngModel)]="block.config.showPlayerTitle"
												[name]="block.id+'-config-showPlayerTitle'">
											</mat-slide-toggle>
										</bb-form-element>
									</div>

									<div class="channel-group-block">
										<bb-form-element [form]="form" [label]="'SHOW_DESCRIPTION' | translate"
											theme="light-v2-row">
											<mat-slide-toggle [(ngModel)]="block.config.showDescription"
												[name]="block.id+'-config-showDescription'">
											</mat-slide-toggle>
										</bb-form-element>
									</div>

									<!-- Player nested blocks: layout / playlist options -->
									<div class="channel-group-block">
										<div class="channel-group-block no-padding-x no-padding-bottom">
											<bb-form-element [form]="form" [required]="true" theme="light-v2"
												[label]="'LAYOUT' | translate" [hideRequiredMark]="true">
												<bb-radio-list [valueOnlyModel]="true" mode="image"
													[name]="block.id+'-config-layout'" [(ngModel)]="block.config.layout"
													[options]="layoutOptions" maxColumns="3">
												</bb-radio-list>
											</bb-form-element>
										</div>

										<mat-form-field *ngIf="block.config.layout === 'below'" appearance="fill"
											class="full-width margin-bottom">
											<mat-hint>{{"PLAYLIST_OPTIONAL" | translate}}</mat-hint>
											<mat-label>{{'TITLE' | translate}}</mat-label>
											<input [(ngModel)]="block.config.playlistTitle" matInput
												(mousedown)="$event.stopPropagation()"
												[name]="block.id+'-config-playlistTitle'">
										</mat-form-field>

										<div class="channel-group-block dark">
											<bb-form-element [form]="form"
												[label]="'SHOW_PLAYLIST_VIDEO_TITLES' | translate" theme="light-v2-row">
												<mat-slide-toggle [(ngModel)]="block.config.showClipTitles"
													[name]="block.id+'-config-showClipTitles'">
												</mat-slide-toggle>
											</bb-form-element>
										</div>

										<div *ngIf="block.config.layout === 'below'" class="channel-group-block dark">
											<bb-form-element [form]="form" [required]="true" theme="light-v2"
												[label]="'SELECT_PLAYLIST_LAYOUT' | translate" [hideRequiredMark]="true">
												<bb-radio-list [valueOnlyModel]="true" mode="image"
													[name]="block.id+'-config-playlistLayout'"
													[(ngModel)]="block.config.playlistLayout" [options]="playlistOptions"
													maxColumns="3">
												</bb-radio-list>
											</bb-form-element>
										</div>
									</div>
								</div>
							</ng-container>
							<!-- END switch -->

							<div class="button-container">
								<bb-button theme="light-v2" (click)="collapseElement(i, false)">{{ "CLOSE" | translate }}
								</bb-button>
							</div>
						</bb-collapsible>
					</div>
				</ng-container>
			</div>
		</div>
		
		<!-- Featured Header Config Template -->
		<ng-template #featuredConfigTemplate let-config="config" let-renderId="renderId" let-isHeader="isHeader">
			<div class="channel-group-block no-padding-bottom ">
				<mat-form-field appearance="fill" class="full-width">
					<mat-label>{{"CONTENT_TYPE" | translate}}</mat-label>
					<mat-select [(ngModel)]="config.contentType"
						(ngModelChange)="config.contentId = null"
						[name]="renderId + '-config-contentType'">
						<mat-option *ngFor="let contentType of contentTypes"
							[value]="contentType.value">
							{{ contentType.label | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<!-- display entity selector base on contentType chosen (resets when changing contentType) -->
				<ng-container *ngFor="let type of contentTypes">
					<ng-container *ngIf="config.contentType === type.value">
						<mat-form-field appearance="fill" class="full-width pointer">
							<mat-label>{{ 'SELECT_'+type.label | translate }}</mat-label>
							<bb-entity-selector theme="light-v2" [inMatFormField]="true"
								[disableClear]="true" [hideThumbnail]="true" [hideIcons]="true"
								[entityType]="type.value" [(ngModel)]="config.contentId"
								[name]="renderId + '-config-contentId'" placeholder="" [filterSet]="[{
									filters: [{
										type: type.value,
										field: 'status',
										operator: 'isNot',
										value: 'draft'
									}]
								}, {
									filters: [{
										type: type.value,
										field: 'mediatype',
										operator: 'is',
										value: 'video'
									}, {
										type: type.value,
										field: 'type',
										operator: 'isOneOf',
										value: ['Project', 'MediaClipList']
									}]
								}]"></bb-entity-selector>
						</mat-form-field>
					</ng-container>
				</ng-container>
			</div>

			<bb-form-element [form]="form" theme="light-v2" [label]="'FEATURED_IMAGE' | translate"
				class="margin-bottom">
				<bb-logo-selector [showDropZone]="true" [name]="renderId + '-config-featuredImageId'"
					[useType]="'commercial'" [mediaTypes]="['image']"
					[(entityId)]="config.featuredImageId" [theme]="'light-v2'"
					[autoPublish]="true" (entityIdChange)="elementLogoChanged($event)"
					[dropTextRecommendation]="isHeader ? 'CHANNEL_FEATURED_HEADER_IMAGE_RECOMMENDATION' : 'CHANNEL_FEATURED_IMAGE_RECOMMENDATION'">
				</bb-logo-selector>
			</bb-form-element>

			<bb-form-element *ngIf="isHeader" [form]="form" theme="light-v2" [label]="'LOGO' | translate"
				class="margin-bottom">
				<bb-logo-selector [showDropZone]="true" [name]="renderId + '-config-logoImageId'"
					[useType]="'commercial'" [mediaTypes]="['image']"
					[(entityId)]="config.logoImageId" [theme]="'light-v2'"
					[autoPublish]="true" (entityIdChange)="elementLogoChanged($event)"
					[dropTextRecommendation]="'CHANNEL_HEADER_FILE_RECOMMENDATION'">
				</bb-logo-selector>
			</bb-form-element>

			<mat-form-field appearance="fill" class="full-width">
				<mat-label>{{'FEATURED_TITLE' | translate}}</mat-label>
				<input [(ngModel)]="config.header" matInput
					(mousedown)="$event.stopPropagation()" [name]="renderId + '-config-header'">
			</mat-form-field>
			<mat-form-field *ngIf="isHeader" appearance="fill" class="full-width">
				<mat-label>{{'DESCRIPTION_TEXT' | translate}}</mat-label>
				<textarea [(ngModel)]="config.description" matInput
					(mousedown)="$event.stopPropagation()" [name]="renderId + '-config-description'"></textarea>
			</mat-form-field>
		</ng-template>

		<!-- Add new element button -->
		<div id="add-element-button" [ngClass]="{open: addElementMenuOpen}" (click)="openAddElementMenu()"
			cdkOverlayOrigin #addElement="cdkOverlayOrigin">
			<button type="button" mat-fab color="primary" [title]="'ADD_BLOCK' | translate">
				<i class="far fa-plus fa-xl "></i>
			</button>
		</div>
	</div>
</div>
